// Angular
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {
  BaseComponent,
  BrandIconUtil,
  ErrorPageComponent,
  ForwarderGuard,
  IncorrectLoginComponent,
  canDeactivateGuard,
  OfficeSettingsComponent,
  AuthenticatedGuard,
} from "@cai-common";

const routes: Routes = [
  {
    "path": "register",
    "loadChildren": () =>
      import(
        "../../../cai-common/src/lib/components/register/register.module"
      ).then((m) => m.RegisterModule),
    "title": `${BrandIconUtil.fetchDomainTitle()}: Register`,
  },
  {
    "path": "register/grossfuchs",
    "redirectTo": "/register?type=forwarder&referral=GrssFchs",
    "pathMatch": "full",
  },
  {
    "path": "register/turkishcargo",
    "redirectTo": "/register?type=forwarder&referral=TrksCrgo",
    "pathMatch": "full",
  },
  {
    "path": "auth/register",
    "redirectTo": "register",
    "pathMatch": "full",
    "title": `${BrandIconUtil.fetchDomainTitle()}: Register`,
  },
  {
    "path": "auth",
    "loadChildren": () =>
      import("../../../cai-common/src/lib/components/auth/auth.module").then(
        (m) => m.AuthModule,
      ),
  },
  {
    "path": "",
    "redirectTo": "auth/login",
    "pathMatch": "full",
    "title": `${BrandIconUtil.fetchDomainTitle()}`,
    "data": {
      "description":
        "Easily manage your bookings and shipment tracking with one account using CargoMART. Sign in or Register to access your account dashboard.",
    },
  },
  {
    "path": "",
    "component": BaseComponent,
    "children": [
      {
        "path": "error/404",
        "component": ErrorPageComponent,
        "data": {
          "type": "error-v6",
          "code": 404,
          "title": "404... Page not found",
          "desc": "Page not found",
        },
      },
      {
        "path": "error/403",
        "component": ErrorPageComponent,
        "data": {
          "type": "error-v6",
          "code": 403,
          "title": "403... Access forbidden",
          "desc": "Looks like you don't have permission to access for requested page.<br> Please, contact administrator",
        },
      },
      {
        "path": "error/498",
        "component": ErrorPageComponent,
        "data": {
          "type": "error-v1",
          "code": 498,
          "title": "498... Invalid/Expired Token",
          "desc": "Looks like your token is invalid/expired.<br> Please request for a new token",
        },
      },
      {
        "path": "error/incorrect-login",
        "component": IncorrectLoginComponent,
      },
      {
        "path": "forwarder",
        "loadChildren": () =>
          import("./pages/forwarder/forwarder.module").then(
            (m) => m.ForwarderModule,
          ),
        "canActivate": [ForwarderGuard],
      },
      {
        "path": "shipment-details",
        "loadChildren": () =>
          import("./pages/quote-detail/quote-detail.module").then(
            (m) => m.QuoteDetailModule,
          ),
      },
      {
        "path": "airline",
        "loadChildren": () =>
          import("./pages/airline/airline.module").then((m) => m.AirlineModule),
      },
      {
        "path": "settings/office-settings",
        "component": OfficeSettingsComponent,
        "canActivate": [AuthenticatedGuard],
      },
    ],
  },

  { "path": "**", "redirectTo": "error/404", "pathMatch": "full" },
  { "path": "error/**", "redirectTo": "error/404", "pathMatch": "full" },
  { "path": "auth/**", "redirectTo": "error/404", "pathMatch": "full" },
  { "path": "**/**", "redirectTo": "error/404", "pathMatch": "full" },
];

@NgModule({
  "imports": [RouterModule.forRoot(routes)],
  "exports": [RouterModule],
  "providers": [canDeactivateGuard, ForwarderGuard, AuthenticatedGuard],
})
export class AppRoutingModule {}
